import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedDashboardSample, VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { buildVoltageProfile } from './voltage-profile.utils';

@Component({
  selector: 'app-voltage-speed-profile',
  templateUrl: './voltage-profile.component.html',
  styleUrls: ['./voltage-profile.component.css']
})
export class VoltageSpeedProfileComponent implements OnChanges {
  @Input() summary: VoltageSpeedDashboardSummary | null = null;
  @Input() samples: VoltageSpeedDashboardSample[] = [];

  profile = buildVoltageProfile(null, []);

  ngOnChanges(): void {
    this.profile = buildVoltageProfile(this.summary, this.samples);
  }
}
